<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        NOVO EVENTO
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"
              >Cadastro de {{ isAT ? "Agenda" : "Encontro" }}</slot
            >
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <app-group-solution-combobox
              :filter="payload"
              @onChange="changeGroup"
              :name="
                isAT
                  ? 'Grupo/Iniciativa'
                  : isSala
                  ? 'Grupo'
                  : 'Grupo de Trabalho/Produto'
              "
            >
            </app-group-solution-combobox>
          </v-col>
        </v-row>
        <v-row v-if="municipioGrupoSolucao">
          <v-col>
            <v-text-field
              :label="`Eixo`"
              v-model="municipioGrupoSolucao"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="estado !== 'SC'">
          <v-col>
            <v-text-field
              :label="`Nome ${isAT ? 'da agenda' : 'do encontro'}`"
              v-model="payload.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00h:00m"
              @blur="setDuracao()"
            ></v-text-field>
          </v-col>

          <v-col
            v-if="
              config.verDuracaoCalendario && groupsConfig.verDuracaoCalendario
            "
          >
            <v-text-field
              v-model="payload.duracaoString"
              v-mask="['##:##', '###:##', '####:##']"
              label="Duração do Evento"
              placeholder="00h:00m"
              @blur="setFimString()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00h:00m"
              @blur="setDuracao()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.solucoesEvento.length > 0">
          <v-col md="9" sm="9" lg="9">
            <v-text-field
              :label="`${
                isAT ? 'Iniciativa da agenda' : 'Solução do encontro'
              }`"
              v-model="payload.solucoesEvento[0].nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="
            payload.solucoesEvento.length > 0 &&
            payload.solucoesEvento[0].monitoramento === 2
          "
        >
          <v-col md="3" sm="3" lg="3">
            <v-radio-group
              v-model="payload.solucoesEvento[0].tipoMonitoramentoEvento"
            >
              <v-radio label="Trabalho de Escritório" value="1"></v-radio>
              <v-radio label="Visita" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <template v-if="payload.solucoesEvento.length > 0">
          <v-row>
            <v-col md="9" sm="9" lg="9">
              <v-combobox
                v-model="payload.tarefasEvento"
                :items="tarefas"
                class="task-combobox"
                chips
                clearable
                :label="`${isAT || isGov ? 'Atividades' : 'Tarefas'}`"
                :hint="
                  tarefas.length === 0
                    ? podeCriarNovaTarefa
                      ? `Sem ${
                          isAT || isGov ? 'atividades' : 'tarefas'
                        } disponíveis. Para criar uma nova, clique no botão + Tarefa.`
                      : `Sem ${
                          isAT || isGov ? 'atividades' : 'tarefas'
                        } disponíveis para seleção.`
                    : ''
                "
                persistent-hint
                item-text="nome"
                item-value="municipioTarefaId"
                multiple
                :disabled="tarefas.length === 0"
                :item-disabled="disableTasks"
                :menu-props="{ auto: true }"
                @change="normalizeTarefasEvento"
              >
                <template v-slot:no-data>
                  <div class="px-3 py-2 caption grey--text text--darken-1">
                    Nenhuma
                    {{ isAT || isGov ? "atividade" : "tarefa" }} encontrada.
                    <template v-if="podeCriarNovaTarefa">
                      Para criar uma nova, clique no botão + Tarefa.
                    </template>
                  </div>
                </template>
                <template v-slot:item="{ item, attrs }">
                  <template v-if="!attrs.disabled">
                    <v-icon>{{ icon(attrs.inputValue) }}</v-icon>
                  </template>
                  <div class="mr-1 ml-1">
                    {{ item.nome }} | Horas: {{ item.horas }}h
                  </div>

                  <template v-if="attrs.disabled">
                    <v-icon color="rgba(0, 0, 0, 0.38)">mdi-check</v-icon>
                  </template>
                </template>
                <template v-slot:selection="{ attrs, item, disabled }">
                  <v-chip close @click:close="removeTarefa(item)">
                    <strong>{{ item.nome }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col md="3" sm="3" lg="3" v-if="!novaTarefa && criarTarefa()">
              <v-btn
                ref="addTaskButton"
                color="primary"
                :class="{ 'highlight-add-task': highlightAddTask }"
                @click="novaTarefa = true"
              >
                + Tarefa</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="novaTarefa">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ payload.novaTarefa.nome || "Nova Tarefa" }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col
                    ><v-text-field
                      v-model="payload.novaTarefa.nome"
                      label="Nome"
                    >
                    </v-text-field
                  ></v-col>

                  <v-col class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      @click="
                        () => {
                          novaTarefa = false;
                          payload.novaTarefa = {};
                        }
                      "
                      >Remover</v-btn
                    >
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </template>
        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-select
              v-model="payload.convidadosEvento"
              :items="membros"
              chips
              label="Membros"
              item-text="nome"
              multiple
              :return-object="true"
            >
              <template slot="no-data"> Nenhum membro retornado </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              :grupo="payload.grupo"
              @onSave="getMembers"
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verParcialAcaoFinalizada &&
              groupsConfig.verParcialAcaoFinalizada)
          "
        >
          <v-col class="tipos">
            <div>
              <v-radio-group v-model="payload.encontroType" row>
                <v-radio label="Parcial" value="Parcial"></v-radio>
                <v-radio
                  label="Ação Finalizada"
                  value="Ação Finalizada"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-col>
          <v-col v-if="verTipoEncontro">
            <combobox-encontro-tipo :filter="payload"></combobox-encontro-tipo>
          </v-col>
        </v-row>

        <v-row v-if="isAT">
          <v-col>
            <v-checkbox
              v-model="payload.sensibilizacao"
              id="sensibilizacao"
              color="primary"
              label="Sensibilização"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.emAndamento"
              id="emAndamento"
              color="primary"
              label="Em Andamento"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.finazacao"
              id="finazacao"
              color="primary"
              label="Finalização"
            />
          </v-col>
        </v-row>

        <v-row v-if="repeatedInvite">
          <v-col>
            <v-alert border="top" color="red lighten-2" dark>
              Já existe outro evento para o mesmo membro na mesma data
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  cityAPI,
  AppGroupSolutionCombobox,
  citySolutionAPI,
} from "@/modules/city";
import { meetingAPI } from "@/modules/calendar";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";
import moment from "moment";
import Swal from "sweetalert2";
import { dataHoraRegexValidator } from "@/helpers/validator";
import ComboboxEncontroTipo from "@/components/calendar/encontroTipo/ComboboxEncontroTipo";
export default {
  name: "AppModalInsertMeeting",
  props: {
    dialog: { type: Boolean, default: false },
    meetings: { type: Array },
  },
  components: {
    AppGroupSolutionCombobox,
    AppModalInsertMember,
    ComboboxEncontroTipo,
  },
  data() {
    return {
      panel: 0,
      payload: {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null,
        novaTarefa: {},
        encontroType: "Parcial",
        encontrosTipoId: 1,
      },
      menu: "",
      menu2: "",
      date: null,
      time: null,
      eixos: [],
      tarefas: [],
      membros: [],
      showDialog: this.dialog,
      municipio: {},
      novaTarefa: false,
      highlightAddTask: false,
      lastGrupoId: null,

      estado: this.$store.state.uf,
      repeatedInvite: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    icon(item) {
      if (item) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    criarTarefa() {
      if (this.podeCriarTarefaNoCalendario) {
        const todasRealizadas = this.tarefas.every((item) => item.realizada);
        if (todasRealizadas && this.podeCriarTarefaApenasSemComboCalendario) {
          return true;
        }

        if (
          this.tarefas.length > 0 &&
          this.podeCriarTarefaApenasSemComboCalendario
        ) {
          return false;
        }

        return true;
      }

      return this.podeCriarTarefaNoCalendario;
    },
    close() {
      this.showDialog = false;

      // Reset completo do payload
      this.payload = {
        nome: null,
        grupoId: 0,
        grupo: null,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null,
        novaTarefa: {},
        encontroType: "Parcial",
        encontrosTipoId: 1,
      };

      // Reset de outras variáveis relacionadas
      this.novaTarefa = false;
      this.tarefas = [];
      this.membros = [];
      this.repeatedInvite = false;
      this.lastGrupoId = null;

      // Força atualização para garantir que os componentes filhos sejam notificados
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    getTasks() {
      this.setLoading(true);

      cityTaskAPI
        .getTasks(
          this.payload.solucoesEvento.map(function (item) {
            return item.municipioSolucaoId;
          })
        )
        .then((resp) => {
          this.tarefas = resp.data.filter((response) => {
            return !response.desabilitado;
            // this.tarefas = resp.data
          });

          if (
            !this.isFullAdmin &&
            (!this.config.visualizaTarefasExecutadas ||
              !this.groupsConfig.visualizaTarefasExecutadas)
          ) {
            this.tarefas = this.tarefas.filter((item) => !item.realizada);
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${
              this.isAT || this.isGov ? "atividades" : "tarefas"
            }`
          );
        });
    },
    testaHorasEntregasContrato() {
      let contratoId;
      const findContrato =
        this.payload.solucoesEvento[0]?.contratoRelacao?.usuarioId ==
        this.user?.usuarioId;

      if (!this.payload.solucoesEvento[0]?.contratoId) {
        this.testarConfirmacao();
      } else {
        let contratoWithMunicipioSolucaoContrato =
          this.payload.solucoesEvento[0]?.municipioSolucaoContrato
            ?.filter(
              (item) => item?.contrato?.usuarioId == this.user?.usuarioId
            )
            .map((item) => item?.contratoId);

        let contratoWithMunicipioSolucao = null;

        if (findContrato) {
          contratoWithMunicipioSolucao =
            this.payload.solucoesEvento[0]?.contratoRelacao.contratoId;
        }

        contratoId =
          contratoWithMunicipioSolucaoContrato?.length == 0
            ? contratoWithMunicipioSolucao
            : contratoWithMunicipioSolucaoContrato[0];

        if (contratoId) {
          this.setLoading(true);

          cityTaskAPI.testaHoras(contratoId).then((resp) => {
            this.setLoading(false);

            const { data: horas } = resp;
            this.testarConfirmacao(horas);
          });
        } else {
          this.testarConfirmacao();
        }
      }
    },
    testarConfirmacao(horas) {
      let erro = false;
      if (horas) {
        let verificarDataHorasAgendadas =
          this.verificarDataHorasAgendadas(horas);
        let verificarDataHoraAprovadas =
          this.verificarDataHorasAprovadas(horas);

        if (!verificarDataHorasAgendadas || !verificarDataHoraAprovadas) {
          this.$notification.error(
            "A(s) tarefa(s) ultrapassa(m) o limite de horas do contrato"
          );
          erro = true;
        }
      }
      if (!erro) {
        if (this.verTipoEncontro && !this.payload.encontrosTipoId) {
          this.$notification.error(
            "É obrigatório o preenchimento do Tipo de Execução."
          );
        }
        if (
          !this.payload.inicioString ||
          this.payload.inicioString.length < 16
        ) {
          this.$notification.error(
            "É obrigatório o preenchimento de data e hora de início do evento"
          );
        } else if (
          !dataHoraRegexValidator.test(this.payload.inicioString) ||
          !dataHoraRegexValidator.test(this.payload.fimString)
        ) {
          this.$notification.error("Data final ou inicial está inválida.");
        } else if (
          !this.payload.fimString ||
          this.payload.fimString.length < 16
        ) {
          this.$notification.error(
            "É obrigatório o preenchimento de data e hora de término do evento"
          );
        } else if (
          moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isBefore(
            moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
          )
        ) {
          this.$notification.error(
            "A data final do evento não pode ser menor que a data inicial do evento"
          );
        } else if (
          moment(this.payload.inicioString, "DD/MM/YYYY HH:mm").isBefore(
            moment().subtract(1, "year")
          )
        ) {
          this.$notification.error(
            "A data inicial do evento não pode ser anterior a 1 ano"
          );
        } else if (
          moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isAfter(
            moment().add(1, "year")
          )
        ) {
          this.$notification.error(
            "A data final do evento não pode ser superior a 1 ano"
          );
        } else if (this.repeatedMeetings() && !this.repeatedInvite) {
          this.$notification.error(
            "Já existe outro evento do mesmo grupo na mesma data"
          );
        } else {
          if (this.podeCriarEventoSemTarefaCalendario) {
            if (
              this.payload.tarefasEvento.length == 0 &&
              !this.payload.novaTarefa.nome
            ) {
              this.alertTarefa();
            } else {
              this.alertaSalvarEncontro();
            }
          } else {
            if (
              this.payload.tarefasEvento.length == 0 &&
              !this.payload.novaTarefa.nome
            ) {
              this.$notification.error(
                "É necessário selecionar ao menos uma tarefa para salvar o encontro"
              );
            } else {
              this.alertaSalvarEncontro();
            }
          }
        }
      }
    },
    verificarDataHorasAgendadas(resp) {
      const soma =
        resp.horasAgendadas +
        this.payload.tarefasEvento.reduce((acc, tarefa) => {
          return acc + tarefa.horas;
        }, 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    verificarDataHorasAprovadas(resp) {
      const soma =
        resp.horasAprovadas +
        this.payload.tarefasEvento.reduce((acc, tarefa) => {
          return acc + tarefa.horas;
        }, 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    disableTasks(item) {
      return item.realizada;
    },
    changeGroup() {
      this.getMembers();
      this.payload.tarefasEvento = [];
      this.removeSolucao();
    },
    getMembers() {
      const currentGrupoId = this.payload?.grupo?.grupoId ?? null;
      const grupoChanged = currentGrupoId !== this.lastGrupoId;
      const previousSelections =
        grupoChanged || !this.payload?.tarefasEvento?.length
          ? []
          : [...this.payload.tarefasEvento];

      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;

          this.getMembersByGroup();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getMembersByGroup({ grupoChanged = false, previousSelections = [] } = {}) {
      memberAPI
        .getMembers(this.payload.grupo.grupoId)
        .then((resp) => {
          if (
            this.isFullAdmin ||
            (this.config.carregaMembrosGrupos &&
              this.groupsConfig.carregaMembrosGrupos)
          )
            this.payload.convidadosEvento = resp.data;
          else this.payload.convidadosEvento = [];
          this.payload.grupoId = this.payload.grupo.grupoId;
          this.lastGrupoId = this.payload.grupoId;
          this.getName();

          if (this.payload.solucoesEvento[0] !== undefined) {
            this.getTasks({ grupoChanged, previousSelections });
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getName() {
      meetingAPI
        .getName(this.payload)
        .then((resp) => {
          this.payload.nome = resp.data;
          if (this.payload.solucoesEvento[0] === undefined) {
            this.setLoading(false);
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Nome do Evento");
        });
    },
    removeSolucao() {
      if (this.payload.solucoesEvento.length > 0) {
        this.payload.solucoesEvento.splice(
          this.payload.solucoesEvento.indexOf(
            this.payload.grupo.municipioSolucao
          ),
          1
        );
      }
      this.payload.solucoesEvento = [...this.payload.solucoesEvento];
      this.tarefas = [];
      this.chipsTarefas = [];
      if (this.payload.grupo.municipioSolucao) {
        this.payload.solucoesEvento.push(this.payload.grupo.municipioSolucao);
      }
    },
    removeTarefa(item) {
      if (this.payload.tarefasEvento.length > 0) {
        this.payload.tarefasEvento.splice(
          this.payload.tarefasEvento.indexOf(item),
          1
        );
      } else {
        this.payload.tarefasEvento = [];
      }
      this.payload.tarefasEvento = [...this.payload.tarefasEvento];
    },
    normalizeTarefasEvento() {
      if (!Array.isArray(this.payload.tarefasEvento)) {
        this.payload.tarefasEvento = [];
        return;
      }

      let tentouCriarDigitandoComCombo = false;

      const tarefasNormalizadas = this.payload.tarefasEvento
        .map((item) => {
          if (typeof item !== "string") {
            return item;
          }

          const nome = item.trim();
          if (!nome) {
            return null;
          }

          const tarefaExistente = this.tarefas.find(
            (tarefa) =>
              tarefa.nome &&
              tarefa.nome.trim().toUpperCase() === nome.toUpperCase()
          );

          if (tarefaExistente) {
            return tarefaExistente;
          }

          if (this.tarefas.length > 0) {
            tentouCriarDigitandoComCombo = true;
            return null;
          }

          return {
            nome,
            municipioSolucaoId: this.payload.grupo?.municipioSolucaoId,
            municipioId: this.payload.municipioId,
            descricao: null,
            horas: parseInt(this.payload.duracaoString) || 0,
            status: 1,
            realizada: 1,
            desabilitado: 0,
            dataFinalizacao: null,
            dataConclusao: null,
          };
        })
        .filter(Boolean);

      const chaves = new Set();
      this.payload.tarefasEvento = tarefasNormalizadas.filter((item) => {
        const chave = item.municipioTarefaId
          ? `id:${item.municipioTarefaId}`
          : `nome:${(item.nome || "").trim().toUpperCase()}`;

        if (chaves.has(chave)) {
          return false;
        }

        chaves.add(chave);
        return true;
      });

      if (tentouCriarDigitandoComCombo) {
        if (this.podeCriarNovaTarefa) {
          this.$notification.info(
            `Para cadastrar nova ${
              this.isAT || this.isGov ? "atividade" : "tarefa"
            }, use o botão + Tarefa.`
          );
        }
      }
    },
    removeMembro(item) {
      this.payload.convidadosEvento.splice(
        this.payload.convidadosEvento.indexOf(item),
        1
      );
      this.payload.convidadosEvento = [...this.payload.convidadosEvento];
    },
    alertaSalvarEncontro() {
      Swal.fire({
        title: `Atenção`,
        text: `Deseja criar o evento com data inicial ${this.payload.inicioString} e data fim ${this.payload.fimString}?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveEncontro();
        }
      });
    },
    alertTarefa() {
      const podeCriar = this.podeCriarNovaTarefa;

      Swal.fire({
        title: "Nenhuma tarefa selecionada",
        html: `<div style="text-align:left;line-height:1.5; font-size:16px;">
            <p style="margin:0 0 10px 0;"><strong>${
              this.isAT ? "Esta agenda" : "Este encontro"
            }</strong> está sem ${
          this.isAT || this.isGov ? "atividades" : "tarefas"
        } selecionadas.</p>
            ${
              podeCriar
                ? `<p style="margin:0 0 8px 0;"><strong>Para criar uma nova ${
                    this.isAT || this.isGov ? "atividade" : "tarefa"
                  }:</strong></p>
            <p style="margin:0 0 12px 0;">Clique no botão <strong>+ Tarefa</strong>, na mesma linha do campo <strong>${
              this.isAT || this.isGov ? "Atividades" : "Tarefas"
            }</strong>, no canto direito.</p>`
                : ``
            }
            <p style="margin:0;"><strong>Deseja continuar mesmo assim?</strong></p>
          </div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: podeCriar ? "Voltar e revisar" : "Fechar",
        confirmButtonText: "Continuar sem tarefa",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.alertaSalvarEncontro();
        } else if (podeCriar) {
          this.highlightTaskButton();
        }
      });
    },
    highlightTaskButton() {
      if (!this.podeCriarNovaTarefa || !this.$refs.addTaskButton) {
        return;
      }

      this.highlightAddTask = true;

      this.$nextTick(() => {
        const button = this.$refs.addTaskButton && this.$refs.addTaskButton.$el;
        if (button && button.scrollIntoView) {
          button.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });

      setTimeout(() => {
        this.highlightAddTask = false;
      }, 2500);
    },
    async save() {
      this.testaHorasEntregasContrato();
    },
    async saveEncontro() {
      this.setLoading(true);
      const tarefasId = this.payload.tarefasEvento
        .map((item) => item.municipioTarefaId)
        .join(",");

      let errorHours;

      if (
        this.payload.solucoesEvento &&
        this.payload.solucoesEvento.length > 0
      ) {
        const { municipioSolucaoId, maxHoras } = this.payload.solucoesEvento[0];

        if (tarefasId && municipioSolucaoId && maxHoras)
          await citySolutionAPI
            .verifyHoursSolution(tarefasId, municipioSolucaoId)
            .then((data) => {
              if (data.data.errorMaxHour) {
                errorHours = "error";

                this.setLoading(false);

                this.$notification.error(
                  "A(s) tarefa(s) ultrapassa(m) o limite de horas da solução"
                );
              }
            });
      }

      if (!errorHours) {
        if (this.payload.novaTarefa.nome)
          this.payload.tarefasEvento.push({
            ...this.payload.novaTarefa,
            municipioSolucaoId: this.payload.grupo.municipioSolucaoId,
            municipioId: this.payload.municipioId,
            descricao: null,
            horas: parseInt(this.payload.duracaoString),
            status: 1,
            realizada: 1,
            desabilitado: 0,
            dataFinalizacao: null,
            dataConclusao: null,
          });

        meetingAPI
          .create(this.payload)
          .then((resp) => {
            this.$emit("onSave");
            this.showDialog = false;

            // Reset completo e consistente
            this.payload = {
              nome: null,
              grupoId: 0,
              grupo: null,
              municipioId: this.$route.params.id,
              solucoesEvento: [],
              tarefasEvento: [],
              convidadosEvento: [],
              observacoes: null,
              novaTarefa: {},
              encontroType: "Parcial",
            };

            this.novaTarefa = false;
            this.tarefas = [];
            this.membros = [];
            this.repeatedInvite = false;
            this.lastGrupoId = null;

            this.setLoading(false);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              `Erro ao cadastrar ${this.isAT ? "agenda" : "encontro"}`
            );
          });
      }
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.municipio = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    repeatedMeetings() {
      let repeated = false;
      this.meetings.forEach((meeting) => {
        if (
          this.payload.grupoId === meeting.grupoId &&
          this.payload.inicioString === meeting.inicioString
        ) {
          repeated = true;

          this.payload.convidadosEvento.forEach((convidadoEvento) => {
            if (
              meeting.convidadosEvento.some(
                (convidado) => convidado.membroId === convidadoEvento.membroId
              )
            ) {
              this.repeatedInvite = true;
            }
          });
        }
      });

      return repeated;
    },
    setInicioString() {
      if (!this.payload.fimString || !this.payload.inicioString) return;
      var a = moment(this.payload.fimString, "DD/MM/YYYY HH:mm");
      var b = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm");
      var diff_s = a.diff(b, "seconds");

      this.payload.duracaoString = moment
        .utc(moment.duration(diff_s, "seconds").asMilliseconds())
        .format("HH:mm");

      this.$forceUpdate();
      return this.payload.fimString;
    },
    setDuracao() {
      if (!this.payload.fimString || !this.payload.inicioString) return;
      if (
        this.config.verDuracaoCalendario &&
        this.groupsConfig.verDuracaoCalendario
      )
        return;
      var a = moment(this.payload.fimString, "DD/MM/YYYY HH:mm");
      var b = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm");
      var diff_s = a.diff(b, "seconds");

      this.payload.duracaoString = moment
        .utc(moment.duration(diff_s, "seconds").asMilliseconds())
        .format("HH:mm");
    },
    setFimString() {
      let inicioDate = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm");
      if (
        this.config.verDuracaoCalendario &&
        this.groupsConfig.verDuracaoCalendario
      ) {
        inicioDate = inicioDate
          .add(this.payload.duracaoString.substring(0, 2), "hours")
          .format("DD/MM/YYYY HH:mm");
      }
      this.payload.fimString = moment(inicioDate, "DD/MM/YYYY HH:mm");
      if (
        this.config.verDuracaoCalendario &&
        this.groupsConfig.verDuracaoCalendario
      ) {
        this.payload.fimString = this.payload.fimString
          .add(this.payload.duracaoString.substring(3), "minutes")
          .format("DD/MM/YYYY HH:mm");
      }

      this.$forceUpdate();
      return this.payload.fimString;
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAT",
      "isFullAdmin",
      "isSala",
      "isGov",
      "user",
    ]),
    verTipoEncontro() {
      return (
        this.isFullAdmin ||
        (this.config.verTipoEncontro && this.groupsConfig.verTipoEncontro)
      );
    },

    municipioGrupoSolucao() {
      return (
        this.payload?.grupo?.municipioSolucao?.municipioGrupoSolucao?.nome || ""
      );
    },
    podeCriarEventoSemTarefaCalendario() {
      return (
        this.isFullAdmin ||
        (this.config.podeCriarEventoSemTarefaCalendario &&
          this.groupsConfig.podeCriarEventoSemTarefaCalendario)
      );
    },
    podeCriarTarefaNoCalendario() {
      return (
        this.isFullAdmin ||
        (this.config.podeCriarTarefaNoCalendario &&
          this.groupsConfig.podeCriarTarefaNoCalendario)
      );
    },
    podeCriarTarefaApenasSemComboCalendario() {
      return (
        this.isFullAdmin ||
        (this.config.podeCriarTarefaApenasSemComboCalendario &&
          this.groupsConfig.podeCriarTarefaApenasSemComboCalendario)
      );
    },
    podeCriarNovaTarefa() {
      return this.criarTarefa();
    },
  },
  created() {
    this.loadCity();
  },
};
</script>
<style lang="scss" scoped>
.executed {
  color: #fff;
  background: #0000003b;
  font-size: 10px;
  padding: 5px;
  border-radius: 30px;
  margin-right: 10px;
}

::v-deep .task-combobox .v-messages {
  margin-top: 8px;
}

::v-deep .task-combobox .v-messages__message {
  color: #0d47a1;
  font-weight: 600;
  background: #e3f2fd;
  border-left: 4px solid #1e88e5;
  border-radius: 6px;
  padding: 8px 10px;
  line-height: 1.4;
}

.highlight-add-task {
  animation: pulse-highlight 0.8s ease-in-out 3;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.35);
}

@keyframes pulse-highlight {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
